import React from "react";
import { Link } from "react-router-dom";
import { Mail, Globe, Phone, Twitter, Linkedin, Facebook, Instagram } from "lucide-react";
import PaymentProcessBanner from "./PaymentProcessBanner";

export default function Footer() {
  return (
    <footer className="border-t border-slate-800 mt-16" style={{background:'#070C18'}} data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 py-14 grid md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div>
          <img
            src="/optivize-logo-white.png"
            alt="Optivize — DBA of Surajit Majhi HUF"
            className="h-16 lg:h-20 w-auto object-contain mb-4"
            style={{maxWidth: "280px"}}
            data-testid="footer-logo-img"
          />
          <p className="text-sm text-slate-400 max-w-xs leading-relaxed">
            Professional website design, SEO, API integration, and automation solutions to grow your business online.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="https://www.facebook.com/Optivize.SM" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-blue-400 transition-colors" title="Facebook" data-testid="footer-fb-link"><Facebook size={18} /></a>
            <a href="#" className="text-slate-500 hover:text-blue-400 transition-colors"><Twitter size={18} /></a>
            <a href="#" className="text-slate-500 hover:text-blue-400 transition-colors"><Linkedin size={18} /></a>
            <a href="#" className="text-slate-500 hover:text-blue-400 transition-colors"><Instagram size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Services</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/services" className="hover:text-blue-400">Website Design</Link></li>
            <li><Link to="/services" className="hover:text-blue-400">SEO Optimization</Link></li>
            <li><Link to="/services" className="hover:text-blue-400">API Integration</Link></li>
            <li><Link to="/services" className="hover:text-blue-400">Business Automation</Link></li>
            <li><Link to="/ai-builder" className="hover:text-blue-400">AI Website Builder</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Company</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/portfolio" className="hover:text-blue-400">Portfolio</Link></li>
            <li><Link to="/blog" className="hover:text-blue-400">Blog</Link></li>
            <li><Link to="/pricing" className="hover:text-blue-400">Pricing</Link></li>
            <li><Link to="/contact" className="hover:text-blue-400">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Legal</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/privacy" className="hover:text-blue-400" data-testid="footer-link-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-blue-400" data-testid="footer-link-terms">Terms of Service</Link></li>
            <li><Link to="/refund-policy" className="hover:text-blue-400" data-testid="footer-link-refund">Refund Policy</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm">Contact</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Mail size={14} className="text-blue-400" /> <a href="mailto:sales@optivize.digital" className="hover:text-blue-300">sales@optivize.digital</a></li>
            <li className="flex items-center gap-2"><Globe size={14} className="text-blue-400" /> optivize.digital</li>
            <li className="flex items-center gap-2"><Phone size={14} className="text-blue-400" /> <a href="tel:+918100671006" className="hover:text-blue-300">+91 81006 71006</a></li>
          </ul>
        </div>
      </div>

      {/* Payment Process By — full-width branded banner */}
      <PaymentProcessBanner/>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 py-5 flex flex-col md:flex-row justify-between gap-2 text-xs text-slate-500">
          <div data-testid="footer-copyright">© 2026 &ldquo;Optivize&rdquo; brand name is Owned and Managed by — SURAJIT MAJHI HUF. All rights reserved.</div>
          <div>Crafted with care in India.</div>
        </div>
      </div>
    </footer>
  );
}
